import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Card,
  CardContent,
  Button,
  Typography,
} from '@mui/material';
import {
  Block,
  Home,
  ArrowBack,
} from '@mui/icons-material';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', display: 'flex', alignItems: 'center', py: 4 }}>
      <Container maxWidth="sm">
        <Card elevation={2}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Block
              sx={{
                fontSize: 80,
                color: 'error.main',
                mb: 2,
              }}
            />
            <Typography variant="h4" fontWeight={700} gutterBottom color="text.primary">
              Zugriff verweigert
            </Typography>
            <Typography variant="h6" color="text.secondary" paragraph>
              403 - Keine Berechtigung
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              Sie haben keine Berechtigung, diese Seite aufzurufen. Diese Funktion ist nur für
              Benutzer mit der Gruppe <strong>"website-manager"</strong> oder der Rolle{' '}
              <strong>"frontend-manager"</strong> verfügbar.
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="outlined"
                startIcon={<ArrowBack />}
                onClick={() => navigate(-1)}
              >
                Zurück
              </Button>
              <Button
                variant="contained"
                startIcon={<Home />}
                onClick={() => navigate('/dashboard')}
              >
                Zum Dashboard
              </Button>
            </Box>

            <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.100', borderRadius: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Falls Sie glauben, dass Sie Zugriff haben sollten, wenden Sie sich bitte an
                Ihren Administrator.
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default Unauthorized;
